import type { IconSvgObject } from './types';

const LinkOffIcon: IconSvgObject = [
  ["path", { d: "M1.99609 2L21.9961 22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.99609 17C7.62926 17 6.99609 17 6.99609 17C4.23467 17 1.99609 14.7614 1.99609 12C1.99609 9.23858 4.23467 7 6.99609 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.9965 15C21.6241 14.1643 21.9961 13.1256 21.9961 12C21.9961 9.23858 19.7575 7 16.9961 7H13.4961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16.9961 17H14.9961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M8.49609 12H11.9961", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LinkOffIcon;
